import Base from './Base';
import Module from './Module';
import QuestionsMatrix from './QuestionsMatrix';
import merge from 'lodash/merge';
import get from 'lodash/get';
import { set } from 'lodash';

const defaults = {
  deviceType: {
    3: {
      encuesta: {
        metadata: {
          strings: {
            titleComments: 'let-comment',
            titleFields: 'let-extra-information',
          },
        },
      },
    },
    6: {
      encuesta: {
        metadata: {
          strings: {
            titleComments: 'let-comment',
          },
          settings: {
            userDataFields: false,
          },
        },
      },
    },
  },
  settings: {
    autoStep: false,
    commentsFields: false,
    userDataFields: false,
    userVisitFields: false,
    pageSize: 4,
    pageBreaks: [],
  },
  strings: {
    titleFields: 'let-extra-information',
    titleComments: 'any-additional-comments',
    motivosTitle: 'main-reason-opinion',
  },
};

export default class Poll extends Base {
  constructor(data) {
    super(data);
    this.metadata = this.metadata || {};
    const newQuestions = [];
    let currentIndex = 0;
    (this.questions || this.preguntas || []).forEach(
      (question, index) => {
        
        if(question.type ==='store' && data.has_store) return;
        if (get(question,'type','question') === 'thanks') {
          newQuestions.push(question);
          currentIndex++;
          return;
        };
        newQuestions.push(new Module({
          ...question,
          poll: this,
          index:currentIndex,
        }));
        currentIndex++
      }
    );
    this.questions = newQuestions;

    this.sortedQuestions = this.getSortedQuestions();
  }

  get preguntas() {
    return this.questions;
  }

  set preguntas(value) {
    this.questions = value;
  }

  get settings() {
    return merge(
      {},
      defaults.settings,
      get(defaults, `deviceType[${this.deviceType}].settings`),
      this.metadata.settings,
      Poll.metadataOverride.settings
    );
  }

  get strings() {
    return merge(
      {},
      defaults.strings,
      get(defaults, `deviceType[${this.deviceType}].strings`),
      this.metadata.strings,
      Poll.metadataOverride.strings
    );
  }

  // /*

  // metadata encuesta
  // pageSize: 3
  // pageBreaks: [
  //   3,
  //   7
  // ];

  // 0: matrix: false
  // 1: matrix: false
  // 2: matrix: false
  // 3: matrix: false
  // 4: matrix: true
  // 5: matrix: true
  // 6: matrix: false
  // 7: matrix: true
  // 8: matrix: true
  // 9: matrix: false

  // Step 1: 0, 1, 2 (matrix: false) by PageSize
  // Step 2: 3 (matrix: false) by PageBreak
  // Step 3: 4, 5 (matrix: true), 6 (matrix: false), 7 (matrix: true) by PageBreak
  // Step 4: 8 (matrix: true), 9 (matrix: false) by EndOfArray
  // */

  getErrors(values) {
    return this.sortedQuestions.reduce((reduced, item) => {
      return [...reduced, ...item.getErrors(values)];
    }, []);
  }

  getNextTo(item) {
    const index = this.sortedQuestions.findIndex(
      (findIndex) => findIndex === item
    );

    // console.log("GET NEXT TO:");
    // console.log(item);
    // console.log("index: ",index," index+1",this.sortedQuestions[index + 1]);

    if (index === -1) {
      return undefined;
    }
    return this.sortedQuestions[index + 1];
  }

  getSortedQuestions() {
    const { pageSize, pageBreaks } = this.settings;

    // const mySteps = [];

    let myCurrentStep = [];
    let myCurrentMatrix = undefined;
    // mySteps.push(myCurrentStep);
    this.questions.forEach((pregunta, index) => {
      if (!(pregunta instanceof Module)) {
        set(pregunta,'index',index);
        myCurrentStep.push(pregunta);
        return;
      }
      const isMatrix = pregunta.getLayout() === 'matrix';
      const group = pregunta.getGroup();

      // const stepIsFull = (() => {
      //   return false;
      //   if (myCurrentStep.length >= pageSize) return true;
      //   if (pageBreaks.includes(index)) return true;
      //   return false;
      // })();

      // if (stepIsFull) {
      //   myCurrentStep = [];
      //   myCurrentMatrix = undefined;
      //   mySteps.push(myCurrentStep)
      // }

      if (isMatrix) {
        if (
          myCurrentMatrix !== undefined &&
          myCurrentMatrix.getGroup() === group
        ) {
          myCurrentMatrix.push(pregunta);
        } else {
          myCurrentMatrix = new QuestionsMatrix([]);
          myCurrentMatrix.poll = this;
          myCurrentMatrix.push(pregunta);
          myCurrentStep.push(myCurrentMatrix);
        }
      } else {
        myCurrentMatrix = undefined;
        myCurrentStep.push(pregunta);
      }
    });

    return myCurrentStep;
  }
}

Poll.metadataOverride = {};
